import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "app/modules/api";
import { ToastService } from "app/shared/service/toast.service";
import * as QRCode from "qrcode";

@Component({
  selector: "app-factor",
  templateUrl: "./factor.component.html",
})
export class FactorComponent implements OnInit {
  qrCodeUrl = "";
  factorForm: FormGroup;
  userId: string;
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
    private toast: ToastService,
    private router: Router
  ) {}
  get code() {
    return this.factorForm.get("code");
  }

  ngOnInit() {
    this.factorForm = new FormGroup({
      code: new FormControl(null, [Validators.required]),
    });
    this.route.queryParams.subscribe((params) => {
      const authenticatorUri = params.authenticatorUri;
      this.userId = params.userId;
      if (authenticatorUri) {
        QRCode.toDataURL(authenticatorUri)
          .then((url) => {
            this.qrCodeUrl = url;
          })
          .catch((err) => {
            console.error("Error generating QR Code:", err);
          });
      }
    });
  }
  submit() {
    this.loading = true;
    this.auth.apiAuths2faPost;
    const Login2FADto = {
      userId: this.userId,
      code: this.code.value,
    };
    this.auth.apiAuths2faPost(Login2FADto).subscribe(
      (response) => {
        console.log('response', response);
        if (response && response.token) {
          localStorage.setItem("currentUser", JSON.stringify(response));
          location.href = "/dashboard";
        }
        this.loading = false;
      },
      (error) => {
        this.toast.showError(error.headers.get("status"));
        this.loading = false;
      }
    );
  }
}
